import { render } from "./Topbar.vue?vue&type=template&id=6096ab67&ts=true"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/thomaswang/Workspace/Latipay/FlashFxUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__